import React, { useCallback, useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { useSelector } from 'react-redux';
import { Download } from '@yme/assets/icons';
import { FADED_VARIANT, ICON_ONLY, SIZE_48 } from '@yme/atoms/button';
import { useWindowSize } from '@yme/common/hooks';
import { getCompareProductsStickyMenuShown } from '@yme/components/Header/redux/selectors';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
import { SCROLL_VALUE_FOR_BUTTON_VISIBILITY } from './constants';
import { ScrollUpButtonStyled } from './styled';
export function ScrollUpButton() {
    const buttonRef = useRef(null);
    const [isButtonInBottom, setIsButtonInBottom] = useState(false);
    const [isScrollUpButtonVisible, setIsScrollUpButtonVisible] = useState(false);
    const { isInfiniteDesktopView } = useWindowSize();
    const { t } = useTranslation();
    const isRightToLeft = useSelector(getRTL);
    const isCompareProductsShown = useSelector(getCompareProductsStickyMenuShown);
    const handleScroll = throttle(() => {
        const currentScrollPosition = window.scrollY;
        const isPortalInBottom = (buttonRef.current &&
            buttonRef.current.parentElement &&
            buttonRef?.current?.parentElement.getBoundingClientRect().bottom <=
                document.documentElement.clientHeight) ||
            false;
        setIsButtonInBottom(isPortalInBottom);
        setIsScrollUpButtonVisible(currentScrollPosition >= SCROLL_VALUE_FOR_BUTTON_VISIBILITY);
    }, 100);
    const scrollTopHandler = useCallback(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }, []);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    if (!isInfiniteDesktopView) {
        return null;
    }
    return (React.createElement(ScrollUpButtonStyled, { isCompareProductsShown: isCompareProductsShown, size: SIZE_48, buttonVariant: FADED_VARIANT, hasIconButton: ICON_ONLY, iconComponent: Download, onClick: scrollTopHandler, isVisible: isScrollUpButtonVisible, isButtonInBottom: isButtonInBottom, buttonRef: buttonRef, isRightToLeft: isRightToLeft, iconRotate: isRightToLeft ? 0 : 180, "aria-label": t('common_scrollToTop_label') }));
}
